import { render, staticRenderFns } from "./ProzessIconSelector.vue?vue&type=template&id=792a3e7f"
import script from "./ProzessIconSelector.vue?vue&type=script&lang=js"
export * from "./ProzessIconSelector.vue?vue&type=script&lang=js"
import style0 from "./ProzessIconSelector.vue?vue&type=style&index=0&id=792a3e7f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports